import mobWebp1 from '../../images/team/mobile/team1.webp';
import mobWebp2x1 from '../../images/team/mobile/team1@2x.webp';
import mobJpeg1 from '../../images/team/mobile/team1.jpg';
import mobJpeg2x1 from '../../images/team/mobile/team1@2x.jpg';
import mobWebp2 from '../../images/team/mobile/team2.webp';
import mobWebp2x2 from '../../images/team/mobile/team2@2x.webp';
import mobJpeg2 from '../../images/team/mobile/team2.jpg';
import mobJpeg2x2 from '../../images/team/mobile/team2@2x.jpg';
import mobWebp3 from '../../images/team/mobile/team3.webp';
import mobWebp2x3 from '../../images/team/mobile/team3@2x.webp';
import mobJpeg3 from '../../images/team/mobile/team3.jpg';
import mobJpeg2x3 from '../../images/team/mobile/team3@2x.jpg';

import tabWebp1 from '../../images/team/tablet/team1.webp';
import tabWebp2x1 from '../../images/team/tablet/team1@2x.webp';
import tabJpeg1 from '../../images/team/tablet/team1.jpg';
import tabJpeg2x1 from '../../images/team/tablet/team1@2x.jpg';
import tabWebp2 from '../../images/team/tablet/team2.webp';
import tabWebp2x2 from '../../images/team/tablet/team2@2x.webp';
import tabJpeg2 from '../../images/team/tablet/team2.jpg';
import tabJpeg2x2 from '../../images/team/tablet/team2@2x.jpg';
import tabWebp3 from '../../images/team/tablet/team3.webp';
import tabWebp2x3 from '../../images/team/tablet/team3@2x.webp';
import tabJpeg3 from '../../images/team/tablet/team3.jpg';
import tabJpeg2x3 from '../../images/team/tablet/team3@2x.jpg';

import deskWebp1 from '../../images/team/desktop/team1.webp';
import deskWebp2x1 from '../../images/team/desktop/team1@2x.webp';
import deskJpeg1 from '../../images/team/desktop/team1.jpg';
import deskJpeg2x1 from '../../images/team/desktop/team1@2x.jpg';
import deskWebp2 from '../../images/team/desktop/team2.webp';
import deskWebp2x2 from '../../images/team/desktop/team2@2x.webp';
import deskJpeg2 from '../../images/team/desktop/team2.jpg';
import deskJpeg2x2 from '../../images/team/desktop/team2@2x.jpg';
import deskWebp3 from '../../images/team/desktop/team3.webp';
import deskWebp2x3 from '../../images/team/desktop/team3@2x.webp';
import deskJpeg3 from '../../images/team/desktop/team3.jpg';
import deskJpeg2x3 from '../../images/team/desktop/team3@2x.jpg';

const firstImages = {
  mobWebp1,
  mobWebp2x1,
  mobJpeg1,
  mobJpeg2x1,
  tabWebp1,
  tabWebp2x1,
  tabJpeg1,
  tabJpeg2x1,
  deskWebp1,
  deskWebp2x1,
  deskJpeg1,
  deskJpeg2x1,
};
const secondImages = {
  mobWebp2,
  mobWebp2x2,
  mobJpeg2,
  mobJpeg2x2,
  tabWebp2,
  tabWebp2x2,
  tabJpeg2,
  tabJpeg2x2,
  deskWebp2,
  deskWebp2x2,
  deskJpeg2,
  deskJpeg2x2,
};
const thirdImages = {
  mobWebp3,
  mobWebp2x3,
  mobJpeg3,
  mobJpeg2x3,
  tabWebp3,
  tabWebp2x3,
  tabJpeg3,
  tabJpeg2x3,
  deskWebp3,
  deskWebp2x3,
  deskJpeg3,
  deskJpeg2x3,
};

export const images = {
  firstImages,
  secondImages,
  thirdImages,
};
